import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector, useDispatch } from "react-redux";
import { setShowManagerSideBar } from "../redux-state/features/global-state/globalStateSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import SidebarLinks from "./sideBarLinks";
import { clearCredentials } from "../redux-state/features/user/userSlice";
import { useNavigate } from "react-router";
function ManagerSideBar() {
  const navigate = useNavigate();
  const show = useSelector((state) => state.globalState.showManagerSideBar);
  const { userName, isAuthenticated } = useSelector((state) => state.userState);
  const dispatch = useDispatch();
  const handleClose = () => dispatch(setShowManagerSideBar(false));
  const handleShow = () => dispatch(setShowManagerSideBar(true));
  const [links, setLinks] = useState([
    {
      text: "الصفحة الرئيسية ",
      icon: "home",
      active: true,
      link: "/manager",
    },
    { text: "إدارة المخزن", icon: "upload", active: false, link: "store" },
    { text: " خروج ", icon: "logOut", active: false },
    // { text: "Messages", icon: "messages", active: false },
  ]);
  useEffect(() => {
    if (!isAuthenticated) navigate("/");
  }, [isAuthenticated]);
  const handleLinkClick = (clickedLink) => {
    // Update the active state of the links
    const updatedLinks = links.map((link) => ({
      ...link,
      active: link.text === clickedLink.text,
    }));
    setLinks(updatedLinks);
    if (clickedLink.icon === "logOut") {
      handleLogout();
    }
    // Handle the click event (e.g., navigate to a different page)
    console.log("Clicked:", clickedLink.icon);
  };
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(clearCredentials());
  };
  return (
    <>
      <button className="btn border border-1 m-2" onClick={handleShow}>
        <FontAwesomeIcon icon={faBars} size="lg" />
      </button>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <h1></h1>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <h5 className="text-center">أمين المخزن</h5>
            <hr />
            <h6>
              {" "}
              مرحبا بك : <strong>{userName}</strong>
            </h6>
            <hr />
          </div>
          <SidebarLinks links={links} onLinkClick={handleLinkClick} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default ManagerSideBar;
